import {Filter, User} from "../../models/table-models";
import {useTranslation} from "react-i18next";
import {useAsyncResource} from "use-async-resource";
import {useGetDistributorBranchBarChartData, useGetDistributorDeviceBarChartData} from "../../utils/clients-hooks";
import {getReferences} from "../../utils/work-hooks";
import ErrorBoundary from "../../components/ErrorBoundary";
import {ErrorComponent} from "../../components/ErrorComponent";
import React, {Suspense, useEffect, useState} from "react";
import {Spinner} from "react-bootstrap";
import {DistributorsBranchBarChart} from "../../components/charts/DistributorsBranchBarChart";
import {DistributorsDeviceBarChart} from "../../components/charts/DistributorsDeviceBarChart";
import {TaskReference} from "../../models/dashboard-models";
import {CustomTable} from "../../components/CustomTable";
import {referencesDistributorTasksTableHeaders} from "../../utils/Enums/TableHeaders";
import {NoDataComponent} from "../../components/NoDataComponent";
import dateFormat from "dateformat";
import {date} from "../../utils/Enums/Common";
import {ExportTasks} from "../../exports/ExportTasks";

export const TasksReferences = ({filter, users, userIds}: { filter: Filter; users: User[], userIds: string[] }) => {
    const {t} = useTranslation('translation', {keyPrefix: 'common'});

    // const [getDistributorBranchBarChartData] = useAsyncResource(useGetDistributorBranchBarChartData, {
    //     ...filter,
    //     tags: userIds
    // });
    // const distributorsBranchBarChartData = getDistributorBranchBarChartData();
    const [getTaskReferences] = useAsyncResource(getReferences, {...filter, tags: userIds});
    const taskReferences = getTaskReferences();
    // const [getDistributorDeviceBarChartData] = useAsyncResource(useGetDistributorDeviceBarChartData, {
    //     ...filter,
    //     tags: userIds
    // });
    // const distributorsDeviceBarChartData = getDistributorDeviceBarChartData();

    return (
        <ErrorBoundary fallback={<ErrorComponent errorText={t('invoices')}/>}>
            {/*<Suspense fallback={<Spinner animation='border'/>}>*/}
            {/*    <div className='text-center w-100 my-3'>*/}
            {/*        <DistributorsBranchBarChart {...{distributorsBranchBarChartData, users}}/>*/}
            {/*    </div>*/}
            {/*    <div className='text-center w-100'>*/}
            {/*        <DistributorsDeviceBarChart {...{distributorsDeviceBarChartData, users}}/>*/}
            {/*    </div>*/}
            {/*</Suspense>*/}
            <Suspense fallback={<Spinner animation='border'/>}>
                {taskReferences.length > 0 && taskReferences.map(({userId, items}, index) => {
                    const user = users.find(user => user.id === userId);
                    return (
                        <TasksReferencesForDistributor key={index} taskReferences={items} user={user}/>
                    );
                })}
            </Suspense>
        </ErrorBoundary>
    )
}

const TasksReferencesForDistributor = ({taskReferences, user}: { taskReferences: TaskReference[]; user?: User }) => {
    const {t} = useTranslation('translation', {keyPrefix: 'common'});
    const [maintenanceTasks, setMaintenanceTasks] = useState<TaskReference[]>([]);
    const [installationTasks, setInstallationTasks] = useState<TaskReference[]>([]);

    useEffect(() => {
        setMaintenanceTasks(() =>
            taskReferences
                .filter((task) => task.taskType !== 'INSTALLATION')
                .sort((a, b) => {
                    if (a.clientName < b.clientName) return -1;
                    if (a.clientName > b.clientName) return 1;
                    if (a.branchName < b.branchName) return -1;
                    if (a.branchName > b.branchName) return 1;
                    return 0;
                })
        );
        setInstallationTasks(() =>
            taskReferences
                .filter((task) => task.taskType === 'INSTALLATION')
                .sort((a, b) => {
                    const statusOrder = ['test', 'unpaid', 'paid'];
                    const statusA = a.isTestPeriod ? 'test' : a.status;
                    const statusB = b.isTestPeriod ? 'test' : b.status;
                    return statusOrder.indexOf(statusA) - statusOrder.indexOf(statusB);
                })
        )
    }, [taskReferences]);
    return (
        <Suspense fallback={<Spinner animation='border'/>}>
            <div className='text-center w-100 mt-3 bordered'>
                <h4 className='mb-3'>
                    {t('NewInstallationTasks') + user?.username}
                </h4>
                <ExportTasks csvData={installationTasks} fileName={user?.username + '-' + t('installationTasks') + "-" + dateFormat(new Date(),date)} wscols={referencesDistributorTasksTableHeaders}/>
                {installationTasks.length > 0 ? <CustomTable
                        columns={{
                            headings: referencesDistributorTasksTableHeaders,
                            items: installationTasks.map(({
                                                              taskType,
                                                              completionTime,
                                                              branchName,
                                                              clientName,
                                                              countDevices,
                                                              consumables,
                                                              invoicePrice,
                                                              documentType,
                                                              paymentType,
                                                              status,
                                                              isTestPeriod,
                                                              testDate
                                                          }) => [
                                completionTime == null ? t("noMaintenance") : completionTime,
                                t(taskType),
                                branchName,
                                clientName,
                                countDevices,
                                consumables,
                                invoicePrice == null ? "-" : invoicePrice,
                                paymentType == null ? "-" : t(documentType) + " " + t(paymentType.toLowerCase()),
                                isTestPeriod ? t("testPeriodTo") + testDate : status == null ? "-" : t(status)
                            ]),
                        }}
                        isNumbered={true}
                        tableData={installationTasks}
                        hasCalculate={true}
                    />
                    :
                    <NoDataComponent noDataText={t('noInstallationReference')}/>
                }
            </div>
            <div className='text-center w-100 mt-3 bordered'>
                <h4 className='mb-3'>
                    {t('NewMaintenanceTasks') + user?.username}
                </h4>
                <ExportTasks csvData={maintenanceTasks} fileName={user?.username + '-' + t('maintenanceTasks') + "-" + dateFormat(new Date(),date)} wscols={referencesDistributorTasksTableHeaders}/>
                {maintenanceTasks.length > 0 ? <CustomTable
                        columns={{
                            headings: referencesDistributorTasksTableHeaders,
                            items: maintenanceTasks.map(({
                                                             taskType,
                                                             completionTime,
                                                             branchName,
                                                             clientName,
                                                             countDevices,
                                                             consumables,
                                                             invoicePrice,
                                                             documentType,
                                                             paymentType,
                                                             status,
                                                             isTestPeriod,
                                                             testDate
                                                         }) => [
                                completionTime == null ? t("noMaintenance") : completionTime,
                                t(taskType),
                                branchName,
                                clientName,
                                countDevices,
                                consumables,
                                invoicePrice == null ? "-" : invoicePrice,
                                paymentType == null ? "-" : t(documentType) + " " + t(paymentType.toLowerCase()),
                                isTestPeriod ? t("testPeriodTo") + testDate : status == null ? "-" : t(status)
                            ]),
                        }}
                        isNumbered={true}
                        tableData={maintenanceTasks}
                        hasCalculate={true}
                    />
                    :
                    <NoDataComponent noDataText={t('noMaintenanceReference')}/>
                }
            </div>
        </Suspense>
    )
}